import "./configs/browser.js";
import { Vibrant, WorkerPipeline } from "@vibrant/core";
export {
  Vibrant,
  WorkerPipeline
};
//# sourceMappingURL=worker.js.map
